function getRandomNumber(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var output = [];
  if (typeof end === 'undefined') {
    end = start;
    start = 0;
  }
  for (var i = start; i < end; i += step) {
    output.push(i);
  }
  return output;
}
export default getRandomNumber;